@if(isLocked()) {
<app-account-locked [minutesLeft]="lockedMinutes()" (onResetPassword)="onForgotPassword()" (onExpired)="onLockExpired()" />
} @else {
<div class="login-page">
    <div class="login-card">

        <!-- Header -->
        <div class="login-header">
            <h1 class="login-title">Log in</h1>
            <p class="login-subtitle">Welcome back. Enter your credentials to continue.</p>
        </div>

        <!-- Form -->
        <form class="login-form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>

            <!-- Email field (shared component) -->
            <app-login-email-input formControlName="email" label="Email" placeholder="name@company.com" inputId="email">
            </app-login-email-input>

            <!-- Password field -->
            <div class="field-group">
                <label class="field-label" for="password">Password</label>
                <div class="input-wrapper" [class.input-wrapper--error]="password.invalid && submitted()">
                    <span class="input-icon">
                        <div class="icon-mask" [style.--icon-url]="'url(assets/icons/password.svg)'"></div>
                    </span>
                    <input id="password" class="input-field" [type]="showPassword() ? 'text' : 'password'"
                        placeholder="Enter password" autocomplete="current-password" formControlName="password"
                        [formControl]="$any(password)" />
                    <button type="button" class="toggle-password" (click)="togglePassword()"
                        [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'">
                        @if (showPassword()) {
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                            <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                            <line x1="1" y1="1" x2="23" y2="23" />
                        </svg>
                        } @else {
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                            <circle cx="12" cy="12" r="3" />
                        </svg>
                        }
                    </button>
                </div>
                @if (password.invalid && password.touched) {
                <span class="field-error">Please enter your password.</span>
                }
            </div>

            <!-- Remember me + Forgot password -->
            <div class="form-row">
                <!-- <label class="remember-me">
                    <input type="checkbox" class="checkbox" formControlName="rememberMe"
                        [formControl]="$any(form.get('rememberMe'))" />
                    <span class="checkbox-custom"></span>
                    <span class="remember-label">Remember me</span>
                </label> -->
                <button type="button" class="forgot-link" (click)="onForgotPassword()">
                    Forgot password?
                </button>
            </div>

            <!-- Error message -->
            @if (errorMessage()) {
            <div class="error-banner" role="alert">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                {{ errorMessage() }}
            </div>
            }

            <!-- Submit button -->
            <button type="submit" class="submit-btn" [class.submit-btn--active]="isFormValid"
                [class.submit-btn--loading]="isLoading()" [disabled]="isLoading()">
                @if (isLoading()) {
                <span class="spinner"></span>
                <!-- <span>Signing in…</span> -->
                } @else {
                Log in
                }
            </button>

        </form>
    </div>
</div>
}